export const ANALYTICS_RANGES = ['TODAY', 'LAST_7_DAYS', 'LAST_30_DAYS', 'LAST_90_DAYS', 'CUSTOM'];
export const ANALYTICS_RANGE_META = {
    TODAY: { key: 'TODAY', label: 'Today', days: 0 },
    LAST_7_DAYS: { key: 'LAST_7_DAYS', label: '7 Days', days: 7 },
    LAST_30_DAYS: { key: 'LAST_30_DAYS', label: '30 Days', days: 30 },
    LAST_90_DAYS: { key: 'LAST_90_DAYS', label: '90 Days', days: 90 },
    CUSTOM: { key: 'CUSTOM', label: 'Custom', days: null },
};
//# sourceMappingURL=analytics.js.map